import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import coreXSystemImage from '../images/CoreXSystemLogo.png';
import backgroundImage from "../images/Background.png";
import textAreaBackground from "../images/UsernamePassBackground.png"
import styles from './IntroPages.module.css';
import corexasLogoWithText from "../images/CorexasLogoWithText.png";
import { getLanguageBasedImage } from '../languageutil/ImageUtil';
import { getText } from '../languageutil/translations';

function EnterCompanyNamePage({ navigate }) {
  const { status } = useParams();
  const [companyName, setCompanyName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [continueButton, setContinueButton] = useState(null);
  const [saveButton, setSaveButton] = useState(null);

  useEffect(() => {
    setContinueButton(getLanguageBasedImage('DevamEtButton.png'));
    setSaveButton(getLanguageBasedImage('KaydetButton.png'));
  }, []);

  const handleFindCompany = async () => {
    try {
      if (!companyName.trim()) {
        setErrorMessage(getText('companyNameRequired'));
        return;
      }

      const simplifiedName = companyName.trim().toLowerCase();

      const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/companies/find?companyName=${encodeURIComponent(simplifiedName)}`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('jwt'),
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.company) {
          localStorage.setItem("companyName", simplifiedName);
          navigate('/intro');
        } else {
          setErrorMessage(getText('companyNotFound'));
        }
      } else {
        setErrorMessage(getText('serverError'));
      }
    } catch (error) {
      console.error('Error finding company:', error);
      setErrorMessage(getText('serverError'));
    }
  };

  const handleCreateCompany = async () => {
    try {
      if (!companyName.trim()) {
        setErrorMessage(getText('companyNameRequired'));
        return;
      }

      const simplifiedName = companyName.trim().toLowerCase();

      const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/companies/create`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('jwt'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ companyName: simplifiedName }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        if (data.company) {
          localStorage.setItem("companyName", simplifiedName);
          navigate('/intro');
        } else {
          setErrorMessage(getText('companyCreateError'));
        }
      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.message || getText('serverError'));
      }
    } catch (error) {
      console.error('Error creating company:', error);
      setErrorMessage(getText('serverError'));
    }
  };

  const handleSubmit = () => {
    if (status === 'saved') {
      handleFindCompany();
    } else if (status === 'new') {
      handleCreateCompany();
    }
  };

  return (
    <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Bookman Old Style", flexDirection: "column" }}>
      <div className={styles.content} style={{}}>
        <img src={coreXSystemImage} alt="CoreXFuture" style={{ position: "absolute", top: "5vh", left: "4vw", height: "25vh", alignSelf: "center" }} />
        <div className={styles.leftside} style={{ paddingTop: "5vh" }}>
          <textarea
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            required
            style={{
              backgroundImage: `url(${textAreaBackground})`,
              backgroundColor: "transparent",
              width: "70%",
              minWidth: "300px",
              backgroundSize: "100% auto",
              backgroundRepeat: "no-repeat",
              border: "0px solid",
              padding: "10px",
              fontSize: "35px",
              resize: "none",
              backgroundPosition: "center",
              marginBottom: "20px",
              color: "white",
              textAlign: "center",
              aspectRatio: 10,
              alignContent: "center",
              fontFamily: "Bookman Old Style"
            }}
            placeholder={getText('companyName')}
          />
          {errorMessage && (
            <div style={{ color: 'red', marginTop: '10px', fontSize: '18px' }}>
              {errorMessage}
            </div>
          )}
        </div>
        <div className={styles.rightside} style={{}}>
          <div className={styles.buttoncontainer} style={{}} >
            <img
              src={status === "saved" ? continueButton : saveButton}
              alt={status === "saved" ? "Continue" : "Save"}
              className={styles.startbutton}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
      <img src={corexasLogoWithText} alt="CoreXFuture" style={{ position: "absolute", height: "10vh", maxHeight: "50px", bottom: "5vh" }} />
    </div>
  );
}

export default EnterCompanyNamePage;